import { UpdateHabitScheduleEntryOptions } from 'features/tasks';
import React from 'react';
import {
  DateFormatOptions,
  initialDateFormat,
  initialTimeFormat,
  TimeFormatOptions,
} from 'shared/types/date-format-options';
import { Goal, NewGoalWithID } from 'shared/types/goal';
import { Habit } from 'shared/types/habit';
import { ScheduleEntryState } from 'shared/types/habit-schedule';
import { ID } from 'shared/types/id';
import { InsightsTimeframes } from 'shared/types/insights';
import { LifeArea } from 'shared/types/life-area';
import { Relationship } from 'shared/types/relationship';
import { RepeatingTask } from 'shared/types/repeating-task';
import { NewTagWithID, Tag } from 'shared/types/tag';
import { Timestamp } from 'shared/types/timestamp';
import { initialWeekStartsOn, WeekDays } from 'shared/types/week-days';

export type DataContextProps = {
  data: {
    goals: (Goal | NewGoalWithID)[];
    lifeAreas: LifeArea[];
    tags: (Tag | NewTagWithID)[];
    relationships: Relationship[];

    goalsToCreate: NewGoalWithID[];
    tagsToCreate: NewTagWithID[];

    timeframe: InsightsTimeframes;
    weekStartsOn: WeekDays;
    timeFormat: TimeFormatOptions;
    dateFormat: DateFormatOptions;
    createHabitAllowed: boolean;
    createHabitTargetAllowed: boolean;
    createHabitIconAllowed: boolean;
    createGoalAllowed: boolean;

    openPremiumDialog: () => void;
    createTag?: (tag: { name: string; color: string }) => Promise<Tag>;
    updateHabitTimeframe?: (timeframe: InsightsTimeframes) => void;
    updateHabitEntry?: (
      habit: Habit | RepeatingTask,
      date: Timestamp,
      type: ScheduleEntryState,
      {
        value,
        increment,
        toggle,
        keepDetailOpen,
      }: UpdateHabitScheduleEntryOptions,
    ) => void;
    openManualEntryLogging?: (habitId: ID, date: Timestamp) => void;
  };
  addGoalToCreate: (name: string) => void;
  addTagToCreate: (name: string) => void;
};

export const DataContext = React.createContext<DataContextProps>({
  data: {
    goals: [],
    lifeAreas: [],
    tags: [],
    relationships: [],

    goalsToCreate: [],
    tagsToCreate: [],

    timeframe: InsightsTimeframes.Week,
    weekStartsOn: initialWeekStartsOn,
    timeFormat: initialTimeFormat,
    dateFormat: initialDateFormat,
    createHabitAllowed: false,
    createHabitTargetAllowed: false,
    createHabitIconAllowed: false,
    createGoalAllowed: false,

    openPremiumDialog: () => {},
    createTag: undefined,
  },
  addGoalToCreate: () => {},
  addTagToCreate: () => {},
});
